export default __webpack_public_path__ + "static/Card29-1d1ecd2be26182fba8199a7b794eda13.png";